import * as APIModels from "../../../models";
import { useState, useEffect, useCallback } from "react";
import { DataService } from "../../../services/DataService";
import { ClientService } from "../../../services/ClientService";
import Party from "./forms/Party";

export default function Parties({
    submission,
    parties,
    onUpdateParties,
    currentDocument,
}: {
    submission: APIModels.Submission;
    parties: APIModels.Party[];
    onUpdateParties: (parties: APIModels.Party[]) => void;
    currentDocument: APIModels.Document | null;
}) {
    const [caseData, setCaseData] = useState(submission.caseData);
    const [partyTypes, setPartyTypes] = useState([] as APIModels.PartyType[]);
    const [completedParties, setCompletedParties] = useState(parties);
    const [selectedParty, setSelectedParty] = useState(
        undefined as APIModels.Party | undefined
    );
    const [selectedPartyIndex, setSelectedPartyIndex] = useState(-1);
    const [loading, setLoading] = useState(false);
    const [selectedDocument, setSelectedDocument] = useState(currentDocument);

    useEffect(() => {
        setSelectedDocument(currentDocument);
        console.log("document updated");
        console.log(currentDocument);
    }, [currentDocument]);

    useEffect(() => {
        if (
            ((submission.caseData?.caseSubTypeID ||
                submission.caseData?.caseTypeID) &&
                (submission.caseData?.caseSubTypeID !=
                    caseData?.caseSubTypeID ||
                    submission.caseData?.caseTypeID != caseData?.caseTypeID ||
                    !caseData?.caseTypeID ||
                    !caseData?.caseSubTypeID ||
                    caseData?.caseTypeID.length == 0 ||
                    caseData?.caseSubTypeID.length == 0)) ||
            partyTypes.length == 0
        ) {
            setLoading(true);
            setCaseData(submission.caseData ?? new APIModels.CaseData());
            DataService.getPartyTypes({
                caseTypeId:
                    submission.caseData?.caseSubTypeID != APIModels.EmptyGuid
                        ? submission.caseData!.caseSubTypeID!
                        : submission.caseData?.caseTypeID ?? "",
            }).then(
                (resp) => {
                    setPartyTypes(resp);
                    setLoading(false);
                },
                (error) => {
                    console.log(error);
                    setLoading(false);
                }
            );
        }
    }, [submission.caseData]);

    useEffect(() => {
        if (
            (caseData?.caseSubTypeID != APIModels.EmptyGuid ||
                caseData?.caseTypeID != APIModels.EmptyGuid) &&
            partyTypes.length > 0
        ) {
            setLoading(true);
            const temp = [...completedParties];
            const updated = [];
            temp?.forEach((v, i) => {
                ClientService.getParty({
                    body: {
                        party: v,
                        attorneyID: submission.attorneyID,
                        caseTypeID:
                            caseData?.caseSubTypeID != null &&
                            caseData?.caseSubTypeID != APIModels.EmptyGuid
                                ? caseData?.caseSubTypeID
                                : caseData?.caseTypeID,
                        countyID: caseData?.countyID,
                        caseSubTypeID:
                            caseData?.caseSubTypeID ?? caseData?.caseSubTypeID,
                        efmeCaseType: caseData?.efmeCaseType,
                    },
                }).then(
                    (resp) => {
                        if (
                            resp.successful === true &&
                            resp.data &&
                            resp.data.partyTypeCode
                        ) {
                            console.log(
                                "TRUE CASE: " + JSON.stringify(resp.data)
                            );
                            temp.splice(i, 1, resp.data);
                        }
                        console.log(
                            "TRUE CASE after: " + JSON.stringify(resp.data)
                        );
                        updated.push(resp.data);
                    },
                    (error) => {
                        console.log("TRUE CASE Errr: " + JSON.stringify(error));
                        console.log(error);
                        updated.push(v);
                    }
                );
            });

            const wait = () => {
                console.log("In Wait ");
                if (updated.length != temp.length) setTimeout(wait, 1000);
                else {
                    setLoading(false);

                    temp.forEach((v, i) => {
                        if (v.partyType === "COMBINE WITH PLAINTIFF") {
                            const plaintiffIndex = temp.findIndex(
                                (pl) => pl.partyTypeCode === v.partyTypeCode
                            );

                            if (plaintiffIndex >= 0) {
                                temp[plaintiffIndex].name =
                                    temp[plaintiffIndex].name +
                                    " A/A/O " +
                                    v.name;
                            }
                        }

                        if (
                            v.address &&
                            v.address.streetAddress === "DEFENDANT ADDRESS"
                        ) {
                            const defendantIndex = temp.findIndex(
                                (pl) => pl.partyTypeCode === v.address?.unit
                            );

                            if (defendantIndex >= 0) {
                                const defendant = temp[defendantIndex];
                                temp[defendantIndex];
                                temp[i].address!.streetAddress =
                                    defendant.address?.streetAddress;
                                temp[i].address!.unit = defendant.address?.unit;
                                temp[i].address!.city = defendant.address?.city;
                                temp[i].address!.state =
                                    defendant.address?.state;
                                temp[i].address!.zip = defendant.address?.zip;
                            }
                        }
                    });

                    onUpdateParties(
                        temp.filter(
                            (p) =>
                                p.partyType !== "COMBINE WITH PLAINTIFF" &&
                                p.partyType !== "NOT AVAILABLE"
                        )
                    );
                }
            };

            setTimeout(wait, 1000);
        }
    }, [partyTypes]);

    useEffect(() => setCompletedParties(parties), [parties]);

    const onSaveParty = (party: APIModels.Party) => {
        let temp = [...completedParties];
        if (selectedPartyIndex > 0) {
            temp.splice(selectedPartyIndex, 1, party);
            setCompletedParties(temp);
        } else {
            temp = [...completedParties, party];
            setCompletedParties([...completedParties, party]);
        }

        setSelectedParty(undefined);
        setSelectedPartyIndex(-1);

        onUpdateParties(temp);
    };

    const onDeleteParty = (index: number) => {
        const temp = [...completedParties];
        temp.splice(index, 1);
        setCompletedParties(temp);
        onUpdateParties(temp);
    };
    return (
        <>
            {loading && (
                <div
                    style={{
                        position: "absolute",
                        left: 0,
                        top: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.25)",
                        zIndex: 500,
                        paddingTop: 350,
                    }}
                    className="d-flex justify-content-center"
                >
                    <div
                        className="spinner-border avatar-lg text-primary m-2"
                        role="status"
                    ></div>
                </div>
            )}
            <div className="mb-3">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="table-responsive">
                            <table className="table table-hover mb-0">
                                <thead>
                                    <tr>
                                        <th>Type</th>
                                        <th>Name</th>
                                        <th>Addess</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {partyTypes.length > 0 &&
                                        completedParties.map((p, i) => {
                                            return (
                                                <tr
                                                    style={{
                                                        border:
                                                            p.firstName &&
                                                            p.firstName.length >
                                                                0
                                                                ? "1px solid #00F"
                                                                : "inherit",
                                                    }}
                                                >
                                                    <td>{p.partyType}</td>
                                                    <td>
                                                        {p.name &&
                                                        p.name.trim() !== ""
                                                            ? p.name
                                                            : `${p.firstName} ${
                                                                  p.middleName ??
                                                                  ""
                                                              } ${
                                                                  p.lastName
                                                              }`.trim()}
                                                    </td>
                                                    <td>
                                                        {p.address &&
                                                            `${
                                                                p.address
                                                                    .streetAddress
                                                            } ${
                                                                p.address
                                                                    .unit ?? ""
                                                            } ${
                                                                p.address.city
                                                            } ${
                                                                p.address.state
                                                            } ${p.address.zip}`}
                                                    </td>
                                                    <td>
                                                        <button
                                                            className="btn btn-primary"
                                                            onClick={() =>
                                                                onDeleteParty(i)
                                                            }
                                                        >
                                                            Delete
                                                        </button>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <Party
                    attorneyId={submission.attorneyID!}
                    partyTypes={partyTypes}
                    onSaveParty={onSaveParty}
                    party={
                        selectedParty ?? {
                            ...new APIModels.Party(),
                            submissionID: submission.id,
                        }
                    }
                    parties={completedParties}
                    currentDocument={selectedDocument}
                />
            </div>
        </>
    );
}
